import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/tr_TR";
const {RangePicker} = DatePicker;

const DateRangeFilter = ({
    value,
    onChange,
    showLabel = true,
    label,
    rightComponent,
    disabled = false,
    disabledDate,
    // Kurye Talepleri filtresindeki gibi takvimin altında hızlı aralık kısayolları
    // ("Bugün", "Bu Hafta" vb.) göstermek için opsiyonel.
    ranges,
    placeholder,
    allowClear = true,
    maxRangeDays
}) => {
    const {t} = useTranslation();
    const [pickingDates, setPickingDates] = useState(null);

    const isOutOfMaxRange = current => {
        if (!maxRangeDays || !pickingDates) return false;
        const [start, end] = pickingDates;
        const tooLate = start && current.diff(start, "days") > maxRangeDays;
        const tooEarly = end && end.diff(current, "days") > maxRangeDays;
        return !!(tooLate || tooEarly);
    };
    return (
        <React.Fragment>
            {showLabel && (
                <h5 style={{display: "flex", alignItems: "center", gap: "8px"}}>
                    {label || `Tarih Aralığı`}
                    {rightComponent && <span>{rightComponent}</span>}
                </h5>
            )}
            <RangePicker
                style={{width: "100%"}}
                locale={locale}
                value={value}
                format={"DD.MM.YYYY"}
                disabled={disabled}
                disabledDate={current => !!disabledDate?.(current) || isOutOfMaxRange(current)}
                onCalendarChange={dates => setPickingDates(dates)}
                onOpenChange={open => setPickingDates(open ? [null, null] : null)}
                ranges={ranges}
                placeholder={placeholder}
                allowClear={allowClear}
                onChange={dates => onChange(dates)}
            />
        </React.Fragment>
    );
};

export default DateRangeFilter;
